import ACTIONS from '../../store/actions';
import { createLogic } from 'redux-logic';
var unauthorizedLogic = createLogic({
  type: [ACTIONS.AUTH_SET_UNAUTHORIZED],
  process: function process(_ref, dispatch, done) {
    var getState = _ref.getState,
        action = _ref.action;
    if (getState().auth.disableAuthRedirect) return done();
    var errorResponse = action.payload && action.payload.response;
    var loginUrl = errorResponse.headers['x-ecrion-loginurl'];

    if (!loginUrl) {
      window.location.href = '/login';
      return done();
    }

    window.location.href = loginUrl;
  }
});
export default [unauthorizedLogic];